import Fetch from "./fetch";

const batchesForFilter = tripFilter => {
  if (tripFilter === "ALL") return ["ONTRIP", "ACTIVE", "COMPLETED"];
  if (tripFilter === "COMPLETED") return ["COMPLETED"];
  if (tripFilter === "ONGOING") return ["ONTRIP", "ACTIVE"];
  return ["ONTRIP", "ACTIVE"];
};

// Fetches /allQLTrips one status at a time (ONTRIP, then ACTIVE, then COMPLETED) instead of in
// one big request, so ONTRIP trips can be shown as soon as they arrive. onBatch is called after
// every request with all trips fetched so far; the same list is returned at the end.
export const fetchQLTripsInBatches = async (data = {}, onBatch, statuses) => {
  let trips = [];
  const batches = statuses || batchesForFilter(data.tripFilter);
  for (let i = 0; i < batches.length; ++i) {
    const response = await Fetch("/bus-tracker/allQLTrips", {
      method: "post",
      data: { ...data, statusBatch: batches[i] }
    });
    // console.log("fetchQLTripsInBatches response", response);
    if (Array.isArray(response)) {
      // Batches are computed up to 30s apart, so a trip that changed status in between can come
      // back twice; keep the copy from the earlier batch.
      const seenTripIds = new Set(trips.map(trip => trip._id));
      trips = trips.concat(response.filter(trip => !seenTripIds.has(trip._id)));
    }
    if (onBatch) {
      onBatch(trips, i === batches.length - 1);
    }
  }
  return trips;
};
